import { format } from '../../hooks/useTranslation';
import TranslationsConfigType from '../../translations/translationType';

const formatSalaryDates = (checkedItems: Record<number, boolean>, translated: TranslationsConfigType) => {
    const list = Object.keys(checkedItems ?? {})
        .map((day) => parseInt(day, 10))
        .filter((day) => !!checkedItems?.[day]);

    if (!list.length) return undefined;
    if (list.length === 1 && list[0] === 32) return translated.salaryInfo.edit.paydays.lastDayOfMonth;
    if (list.length === 1) return format(translated.salaryInfo.edit.paydays.eachMonth, `${list[0]}.`);
    const commaSeparatedString = list
        .map((day) => (day === 32 ? translated.salaryInfo.edit.paydays.lastDay : `${day}.`))
        .join(', ');

    const lastIndexOfComma = commaSeparatedString.lastIndexOf(',');
    const string = `${commaSeparatedString.slice(0, lastIndexOfComma)}${
        translated.salaryInfo.edit.paydays.and
    }${commaSeparatedString.slice(lastIndexOfComma + 1)}`;
    return format(translated.salaryInfo.edit.paydays.eachMonth, string);
};

export default formatSalaryDates;
